import axios from 'axios';

const TemplateService = {
  async getTemplates({ page, search, limit, sortField, sortOrder }) {
    const response = await axios.get('/templates', {
      params: { page, search, limit, sortField, sortOrder },
    });
    return response.data;
  },
  async cloneTemplate({ templateId, folderId }) {
    const response = await axios.post(`/templates/${templateId}/use`, {
      folderId,
    });
    return response.data;
  },
  async createTemplate({ title, placeholders }) {
    const response = await axios.post('/templates', { title, placeholders });
    return response.data;
  },
  async updateTemplate({ id, title, placeholders }) {
    const response = await axios.put(`/templates/${id}`, { title, placeholders });
    return response.data;
  },
  async deleteTemplate(id) {
    const response = await axios.delete(`/templates/${id}`);
    return response.data;
  },
};

export default TemplateService;
